var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{class:{long: _vm.long},attrs:{"name":"fade-in-transition","mode":"out-in","tag":"div"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }